document.addEventListener("DOMContentLoaded", function () {
    $('.slick-product-gallery').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        adaptiveHeight: false,
        asNavFor: '.slick-thumbnails',
        responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    $('.slick-thumbnails').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.slick-product-gallery',
        focusOnSelect: true,
        arrows: false,
        centerMode: true
    });
});
